import React, { useEffect, useState } from 'react';

type LoadingScreenProps = {
  customMessage?: string;
  showFunFacts?: boolean;
};

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  customMessage,
  showFunFacts = true,
}) => {
  const loadingMessages = [
    'Initializing magic...',
    'Setting up your task...',
    'Bringing everything together...',
    'Preparing automation...',
    'Checking all systems...',
  ];

  const funFacts = [
    'Did you know? Cats have over 20 muscles that control their ears.',
    'Fun fact: Honey never spoils. Archaeologists have found pots of honey in ancient tombs that are over 3,000 years old!',
    'Interesting: Bananas are berries, but strawberries aren’t.',
    'Did you know? Octopuses have three hearts.',
  ];

  const [currentMessage, setCurrentMessage] = useState(loadingMessages[0]);
  const [currentFact, setCurrentFact] = useState(funFacts[0]);

  useEffect(() => {
    const messageInterval = setInterval(() => {
      setCurrentMessage((prev) => {
        const nextIndex =
          (loadingMessages.indexOf(prev) + 1) % loadingMessages.length;
        return loadingMessages[nextIndex];
      });
    }, 7000);

    const factInterval = showFunFacts
      ? setInterval(() => {
          setCurrentFact((prev) => {
            const nextIndex = (funFacts.indexOf(prev) + 1) % funFacts.length;
            return funFacts[nextIndex];
          });
        }, 10_000)
      : null;

    return () => {
      clearInterval(messageInterval);
      if (factInterval) {
        clearInterval(factInterval);
      }
    };
  }, [showFunFacts]);

  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center space-y-6 p-4 text-center md:p-9 lg:p-12">
      {/* Animated Loader Dots */}
      <div className="mb-4 flex items-center gap-2 text-gray-700">
        <div className="loader-dot h-2 w-2 animate-bounce rounded-full bg-gray-400" />
        <div className="loader-dot h-2 w-2 animate-bounce rounded-full bg-gray-400 delay-100" />
        <div className="loader-dot h-2 w-2 animate-bounce rounded-full bg-gray-400 delay-200" />
      </div>

      {/* Rotating Loading Messages */}
      <p className="text-lg font-semibold">{customMessage || currentMessage}</p>

      {/* Fun Facts */}
      {showFunFacts && (
        <p className="mt-2 text-sm italic text-gray-500">{currentFact}</p>
      )}
    </div>
  );
};

export default LoadingScreen;
